
import React from "react";

const ZohoForm = () => {
  return (
    <div>
      <iframe
        src="https://forms.zohopublic.com/bajaferries/form/Condicionesmdicas1/formperma/uf9qNwCQwcPp68wh-CaFli4gFeD7ygVvP7Dgh8gcxGE"
        width="100%"
        height="1780px"
        frameBorder="0"
        title="Zoho Form"
        scrolling="no">
            
        </iframe>
    </div>
  );
};

export default ZohoForm;